import React, { useState } from 'react';
import { Download, FileText, Image, Info } from 'lucide-react';
import { __ } from './translations';

const OtherDocumentsSection = ({ documents = [], isAdmin = false }) => {
    const [expandedDocs, setExpandedDocs] = useState({});

    const toggleDescription = (id) => {
        setExpandedDocs(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const getFileIcon = (fileType) => {
        if (fileType && fileType.includes('pdf')) {
            return <FileText className="h-5 w-5 text-red-500" />;
        }
        if (fileType && fileType.includes('image')) {
            return <Image className="h-5 w-5 text-blue-500" />;
        }
        return <FileText className="h-5 w-5 text-gray-500" />;
    };

    if (!documents || documents.length === 0) {
        return isAdmin ? (
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                    {__('Other Documents')}
                </h3>
                <p className="text-gray-500">
                    {__('No other documents uploaded yet.')}
                </p>
            </div>
        ) : null;
    }

    return (
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4">
                {__('Other Documents')}
            </h3>
            <div className="space-y-4">
                {documents.map((doc, index) => (
                    <div key={index} className="p-4 bg-white rounded shadow-sm border border-gray-200">
                        <div className="flex items-start gap-3">
                            <div className="flex-shrink-0 pt-1">
                                {getFileIcon(doc.file?.type)}
                            </div>
                            <div className="flex-grow">
                                <div className='flex items-center justify-between'>
                                    <h5 className="font-medium text-gray-900">
                                        {doc.title}
                                    </h5>
                                    <a
                                        href={doc.file?.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-flex items-center text-sm text-blue-600  hover:text-blue-800"
                                    >
                                        <Download className="h-4 w-4 mr-1" />
                                        {__('Download')}
                                    </a>
                                </div>
                                {doc.description && (
                                    <>
                                        <button
                                            onClick={() => toggleDescription(index)}
                                            className="flex items-center text-xs text-blue-600 mt-1 mb-1 hover:text-blue-800"
                                        >
                                            <Info className="h-3 w-3 mr-1" />
                                            {expandedDocs[index] ? __('Hide description') : __('Show description')}
                                        </button>

                                        {expandedDocs[index] && (
                                            <p className="text-sm text-gray-600 my-2 pl-2 border-l-2 border-gray-200">
                                                {doc.description}
                                            </p>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OtherDocumentsSection;